import React, { useEffect, useState } from "react";
import Wrapper from "../../components/Wrapper/Wrapper";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as logger from "../../../logger";
import {
  getSubscriptionPlans,
  paySubscriptionAction,
  getSubscriptionStatus,
  getPlansAfterCouponApply,
  getPaymentLink,
} from "../../../store/actions/paymentsActionCreator";
import {
  Paper,
  Typography,
  Button,
  Box,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import {
  numberFormatPaisaV2,
  getDateInStringDocumentDDMMMYYYY,
} from "../../../utils/utils";
import { trackDwebEvent } from "../../analytics";
import TextField from "@material-ui/core/TextField";
import clsx from "clsx";
import premiumCss from "./PaymentsCss";
import PremimumInfoCard from "../../components/Card/PremimumInfoCard";
import PremimumInfoFeatures from "../../components/Card/PremimumInfoFeatures";
import DialogTitle from "../../components/Dialog/Dialog";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
const Payments = ({
  payments,
  history,
  dispatchGetSubscriptionStatusAction,
  dispatchPayCouponSubscriptionAction,
  dispatchGetSubscriptionPaymentLinkAction,
  dispatchGetSubscriptionPlanAction,
  dispatchPayForSubscriptionAction,
  user,
}) => {
  const classes = premiumCss();
  const [subscriptionPlans, setSubscriptionPlans] = useState(null);
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponInputError, setCouponInputError] = useState(false);
  const [couponInputHelperText, setCouponInputHelperText] = useState(null);
  const [coupon, setCoupon] = useState(null);
  const [price, setPrice] = useState(0);
  const [priceCoupon, setPriceCoupon] = useState(0);
  const [discountValue, setDiscountValue] = useState(0);
  const [discountType, setDiscountType] = useState(null);
  const [couponDialogOpen, setCouponDialogOpen] = useState(false);

  let premEnabled =
    user &&
    user.configs &&
    user.configs.subscription &&
    user.configs.subscription.enabled &&
    user.configs.subscription.enabled === 1
      ? true
      : false;
  if (!premEnabled) {
    window.location.href = "/404";
  }
  useEffect(() => {
    dispatchGetSubscriptionStatusAction(
      data => {
        logger.log("Payments", "Get user subscription status Success");
      },
      () => {
        logger.log("Payments", "Get user subscription status Failed");
      }
    );
  }, []);

  useEffect(() => {
    if (
      payments.subscriptionStatus &&
      payments.subscriptionPlans &&
      payments.subscriptionPlans.length > 0
    ) {
      trackDwebEvent("Dweb Subscription Page", {
        free_trial_start_date:
          payments &&
          payments.subscriptionStatus &&
          payments.subscriptionStatus.subscriptionStartDateEpoch
            ? payments.subscriptionStatus.subscriptionStartDateEpoch
            : "",
        days_to_free_trial_expiry:
          payments &&
          payments.subscriptionStatus &&
          payments.subscriptionStatus.numberOfDays >= 0
            ? payments.subscriptionStatus.numberOfDays
            : "",
        subscription_amount:
          payments &&
          payments.subscriptionPlans &&
          payments.subscriptionPlans[0] &&
          payments.subscriptionPlans[0].originalPrice
            ? payments.subscriptionPlans[0].originalPrice
            : "",
        amount_to_be_paid:
          payments &&
          payments.subscriptionPlans &&
          payments.subscriptionPlans[0] &&
          payments.subscriptionPlans[0].price
            ? payments.subscriptionPlans[0].price
            : "",
      });
    }
  }, [payments]);

  useEffect(() => {
    if (
      !subscriptionPlans &&
      payments &&
      payments.subscriptionStatus &&
      payments.subscriptionStatus.status &&
      payments.subscriptionStatus.subscriptionType &&
      ((payments.subscriptionStatus.status === "EXPIRED" &&
        payments.subscriptionStatus.subscriptionType === "FREE_TRIAL") ||
        (payments.subscriptionStatus.status === "EXPIRED" &&
          payments.subscriptionStatus.subscriptionType === "PAID") ||
        (payments.subscriptionStatus.status === "ACTIVE" &&
          payments.subscriptionStatus.subscriptionType === "FREE_TRIAL") ||
        (payments.subscriptionStatus.status === "PROCESSING" &&
          payments.subscriptionStatus.subscriptionType === "FREE_TRIAL") ||
        (payments.subscriptionStatus.status === "PROCESSING" &&
          payments.subscriptionStatus.subscriptionType === "PAID") ||
        (payments.subscriptionStatus.status === "ACTIVE" &&
          payments.subscriptionStatus.subscriptionType === "PAID"))
    ) {
      dispatchGetSubscriptionPlanAction(
        data => {
          logger.log("Payments", "Get user subscription plan success");
          if (data.status && data.status.code === 200) {
            let plan =
              data && data.response && data.response[0]
                ? data.response[0]
                : null;
            setSubscriptionPlans(plan);
            if (plan && plan.price) {
              setPrice(plan.price);
            }
          }
        },
        () => {
          logger.log("Payments", "Get user subscription plan failed");
        }
      );
    }
  }, [payments]);
  const handleCouponDialog = () => {
    setCouponDialogOpen(true);
  };
  const handleCouponDialogClose = () => {
    setCouponDialogOpen(false);
    setCouponInputError(false);
    setCouponInputHelperText(null);
    setCouponApplied(false);
    setCoupon(null);
  };
  const handleCouponApply = e => {
    if (coupon) {
      setCouponInputError(false);
      setCouponInputHelperText("");
      var paymentOptionData = {
        subscriptionPlan: subscriptionPlans.subscriptionPlan,
        couponCode: coupon,
      };
      trackDwebEvent("Dweb Subscription Page Coupon Attempted", {
        free_trial_start_date:
          payments &&
          payments.subscriptionStatus &&
          payments.subscriptionStatus.subscriptionStartDateEpoch
            ? payments.subscriptionStatus.subscriptionStartDateEpoch
            : "",
        days_to_free_trial_expiry:
          payments &&
          payments.subscriptionStatus &&
          payments.subscriptionStatus.numberOfDays >= 0
            ? payments.subscriptionStatus.numberOfDays
            : "",
        subscription_amount:
          payments &&
          payments.subscriptionPlans &&
          payments.subscriptionPlans[0] &&
          payments.subscriptionPlans[0].originalPrice
            ? payments.subscriptionPlans[0].originalPrice
            : "",
        amount_to_be_paid:
          payments &&
          payments.subscriptionPlans &&
          payments.subscriptionPlans[0] &&
          payments.subscriptionPlans[0].price
            ? payments.subscriptionPlans[0].price
            : "",
        coupon_code: coupon ? coupon : "",
      });
      dispatchPayCouponSubscriptionAction(
        paymentOptionData,
        data => {
          if (
            data &&
            data.status &&
            data.status.code === 200 &&
            data.response &&
            data.response.amount &&
            data.response.isCouponApplied &&
            data.response.isValidCoupon
          ) {
            trackDwebEvent("Dweb Subscription Page Coupon Applied", {
              free_trial_start_date:
                payments &&
                payments.subscriptionStatus &&
                payments.subscriptionStatus.subscriptionStartDateEpoch
                  ? payments.subscriptionStatus.subscriptionStartDateEpoch
                  : "",
              days_to_free_trial_expiry:
                payments &&
                payments.subscriptionStatus &&
                payments.subscriptionStatus.numberOfDays >= 0
                  ? payments.subscriptionStatus.numberOfDays
                  : "",
              subscription_amount:
                payments &&
                payments.subscriptionPlans &&
                payments.subscriptionPlans[0] &&
                payments.subscriptionPlans[0].originalPrice
                  ? payments.subscriptionPlans[0].originalPrice
                  : "",
              amount_to_be_paid:
                payments &&
                payments.subscriptionPlans &&
                payments.subscriptionPlans[0] &&
                payments.subscriptionPlans[0].price
                  ? payments.subscriptionPlans[0].price
                  : "",
              coupon_code: coupon ? coupon : "",
            });
            setCouponApplied(true);
            setPriceCoupon(Number(data.response.amount));
            setDiscountValue(data.response.discountValue);
            setDiscountType(data.response.discountType);
            setCouponDialogOpen(false);
          } else {
            trackDwebEvent("Dweb Subscription Page Coupon Failed", {
              free_trial_start_date:
                payments &&
                payments.subscriptionStatus &&
                payments.subscriptionStatus.subscriptionStartDateEpoch
                  ? payments.subscriptionStatus.subscriptionStartDateEpoch
                  : "",
              days_to_free_trial_expiry:
                payments &&
                payments.subscriptionStatus &&
                payments.subscriptionStatus.numberOfDays >= 0
                  ? payments.subscriptionStatus.numberOfDays
                  : "",
              subscription_amount:
                payments &&
                payments.subscriptionPlans &&
                payments.subscriptionPlans[0] &&
                payments.subscriptionPlans[0].originalPrice
                  ? payments.subscriptionPlans[0].originalPrice
                  : "",
              amount_to_be_paid:
                payments &&
                payments.subscriptionPlans &&
                payments.subscriptionPlans[0] &&
                payments.subscriptionPlans[0].price
                  ? payments.subscriptionPlans[0].price
                  : "",
              coupon_code: coupon ? coupon : "",
              error_reason:
                data && data.status && data.status.message
                  ? data.status.message
                  : "",
            });
            setCouponApplied(false);
            setCouponInputError(true);
            setCouponInputHelperText("Invalid Coupon");
          }
        },
        data => {
          trackDwebEvent("Dweb Subscription Page Coupon Failed", {
            free_trial_start_date:
              payments &&
              payments.subscriptionStatus &&
              payments.subscriptionStatus.subscriptionStartDateEpoch
                ? payments.subscriptionStatus.subscriptionStartDateEpoch
                : "",
            days_to_free_trial_expiry:
              payments &&
              payments.subscriptionStatus &&
              payments.subscriptionStatus.numberOfDays >= 0
                ? payments.subscriptionStatus.numberOfDays
                : "",
            subscription_amount:
              payments &&
              payments.subscriptionPlans &&
              payments.subscriptionPlans[0] &&
              payments.subscriptionPlans[0].originalPrice
                ? payments.subscriptionPlans[0].originalPrice
                : "",
            amount_to_be_paid:
              payments &&
              payments.subscriptionPlans &&
              payments.subscriptionPlans[0] &&
              payments.subscriptionPlans[0].price
                ? payments.subscriptionPlans[0].price
                : "",
            coupon_code: coupon ? coupon : "",
            error_reason:
              data && data.status && data.status.message
                ? data.status.message
                : "",
          });
        }
      );
    } else {
      setCouponInputError(true);
      setCouponInputHelperText("Please Enter the Coupon");
    }
  };
  const makePayment = paymentOption => {
    var paymentOptionData = {
      subscriptionPlan: paymentOption.subscriptionPlan,
      amount: couponApplied
        ? Number(priceCoupon)
        : parseInt(paymentOption.price),
    };
    if (couponApplied) {
      paymentOptionData.couponCode = coupon;
    }
    trackDwebEvent("Dweb Subscription Page Payment Initiated", {
      free_trial_start_date:
        payments &&
        payments.subscriptionStatus &&
        payments.subscriptionStatus.subscriptionStartDateEpoch
          ? payments.subscriptionStatus.subscriptionStartDateEpoch
          : "",
      days_to_free_trial_expiry:
        payments &&
        payments.subscriptionStatus &&
        payments.subscriptionStatus.numberOfDays >= 0
          ? payments.subscriptionStatus.numberOfDays
          : "",
      subscription_amount:
        payments &&
        payments.subscriptionPlans &&
        payments.subscriptionPlans[0] &&
        payments.subscriptionPlans[0].originalPrice
          ? payments.subscriptionPlans[0].originalPrice
          : "",
      amount_to_be_paid:
        payments &&
        payments.subscriptionPlans &&
        payments.subscriptionPlans[0] &&
        payments.subscriptionPlans[0].price
          ? payments.subscriptionPlans[0].price
          : "",
      coupon_code: coupon ? coupon : "",
    });
    dispatchPayForSubscriptionAction(
      paymentOptionData,
      data => {
        if (
          data &&
          data.status &&
          data.status.code === 200 &&
          data.response &&
          data.response.paymentLink
        ) {
          window.location.href = data.response.paymentLink;
          logger.log("Payments", "Subscription payment Success");
          trackDwebEvent("Dweb Subscription Page Payment Successfull", {
            free_trial_start_date:
              payments &&
              payments.subscriptionStatus &&
              payments.subscriptionStatus.subscriptionStartDateEpoch
                ? payments.subscriptionStatus.subscriptionStartDateEpoch
                : "",
            days_to_free_trial_expiry:
              payments &&
              payments.subscriptionStatus &&
              payments.subscriptionStatus.numberOfDays >= 0
                ? payments.subscriptionStatus.numberOfDays
                : "",
            subscription_amount:
              payments &&
              payments.subscriptionPlans &&
              payments.subscriptionPlans[0] &&
              payments.subscriptionPlans[0].originalPrice
                ? payments.subscriptionPlans[0].originalPrice
                : "",
            amount_to_be_paid:
              payments &&
              payments.subscriptionPlans &&
              payments.subscriptionPlans[0] &&
              payments.subscriptionPlans[0].price
                ? payments.subscriptionPlans[0].price
                : "",
            coupon_code: coupon ? coupon : "",
            order_id:
              data && data.response && data.response.orderId
                ? data.response.orderId
                : "",
          });
        } else {
          trackDwebEvent("Dweb Subscription Page Payment Failed", {
            free_trial_start_date:
              payments &&
              payments.subscriptionStatus &&
              payments.subscriptionStatus.subscriptionStartDateEpoch
                ? payments.subscriptionStatus.subscriptionStartDateEpoch
                : "",
            days_to_free_trial_expiry:
              payments &&
              payments.subscriptionStatus &&
              payments.subscriptionStatus.numberOfDays >= 0
                ? payments.subscriptionStatus.numberOfDays
                : "",
            subscription_amount:
              payments &&
              payments.subscriptionPlans &&
              payments.subscriptionPlans[0] &&
              payments.subscriptionPlans[0].originalPrice
                ? payments.subscriptionPlans[0].originalPrice
                : "",
            amount_to_be_paid:
              payments &&
              payments.subscriptionPlans &&
              payments.subscriptionPlans[0] &&
              payments.subscriptionPlans[0].price
                ? payments.subscriptionPlans[0].price
                : "",
            coupon_code: coupon ? coupon : "",
            error_reason:
              data && data.status && data.status.message
                ? data.status.message
                : "",
            order_id:
              data && data.response && data.response.orderId
                ? data.response.orderId
                : "",
          });
        }
      },
      data => {
        trackDwebEvent("Dweb Subscription Page Payment Failed", {
          free_trial_start_date:
            payments &&
            payments.subscriptionStatus &&
            payments.subscriptionStatus.subscriptionStartDateEpoch
              ? payments.subscriptionStatus.subscriptionStartDateEpoch
              : "",
          days_to_free_trial_expiry:
            payments &&
            payments.subscriptionStatus &&
            payments.subscriptionStatus.numberOfDays >= 0
              ? payments.subscriptionStatus.numberOfDays
              : "",
          subscription_amount:
            payments &&
            payments.subscriptionPlans &&
            payments.subscriptionPlans[0] &&
            payments.subscriptionPlans[0].originalPrice
              ? payments.subscriptionPlans[0].originalPrice
              : "",
          amount_to_be_paid:
            payments &&
            payments.subscriptionPlans &&
            payments.subscriptionPlans[0] &&
            payments.subscriptionPlans[0].price
              ? payments.subscriptionPlans[0].price
              : "",
          coupon_code: coupon ? coupon : "",
          error_reason:
            data && data.status && data.status.message
              ? data.status.message
              : "",
          order_id:
            data && data.response && data.response.orderId
              ? data.response.orderId
              : "",
        });
        logger.log("Payments", "Subscription payment failure");
      }
    );
  };

  const render_coupon_dialog = () => {
    return (
      couponDialogOpen && (
        <Dialog
          fullWidth={true}
          aria-labelledby="coupon-appy-dialog-title"
          maxWidth="xs"
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          open={couponDialogOpen}
          classes={{
            paper: classes.couponDialogPaper,
          }}
        >
          {" "}
          <DialogTitle
            classes={{ root: classes.dialogTitleRoot }}
            id="coupon-appy-dialog-title"
            onClose={handleCouponDialogClose}
          >
            Apply Coupon Code
          </DialogTitle>
          <DialogContent classes={{ root: classes.dialogContentRoot }}>
            <Box display={"flex"} width={"100%"} alignItems={"center"}>
              <TextField
                variant="outlined"
                labelWidth={0}
                fullWidth
                value={coupon}
                onChange={e => {
                  setCouponInputError(false);
                  setCouponInputHelperText(null);
                  setCouponApplied(false);
                  setCoupon(e.target.value);
                }}
                label=""
                error={couponInputError}
                helperText={couponInputHelperText}
                placeholder="Enter Coupon"
                id="standard-start-adornment"
                className={clsx(classes.textField)}
              />
              <Button
                variant="contained"
                onClick={handleCouponApply}
                className={couponApplied ? classes.applied : classes.apply}
                color="primary"
              >
                {couponApplied ? (
                  <span>
                    <CheckIcon />
                    Applied
                  </span>
                ) : (
                  "Apply"
                )}
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )
    );
  };

  const render_premium_info_card = () => (
    <PremimumInfoCard
      subscriptionStatus={
        payments && payments.subscriptionStatus
          ? payments.subscriptionStatus
          : null
      }
      price={numberFormatPaisaV2(Number(price))}
    />
  );

  const render_premium_features = () => (
    <PremimumInfoFeatures
      subscriptionStatus={
        payments && payments.subscriptionStatus
          ? payments.subscriptionStatus
          : null
      }
      price={numberFormatPaisaV2(Number(price))}
    />
  );

  const render_expiry_date = () =>
    payments &&
    payments.subscriptionStatus &&
    payments.subscriptionStatus.isExpired !== undefined && (
      <Typography style={{ marginTop: 20 }}>
        {payments.subscriptionStatus.isExpired
          ? "Your access to Premium expired on "
          : "Your access to Premium expires on "}
        <strong>
          {getDateInStringDocumentDDMMMYYYY(
            payments.subscriptionStatus.subscriptionEndDateEpoch
          )}
        </strong>
      </Typography>
    );

  const render_renew_option = () =>
    payments &&
    payments.subscriptionStatus &&
    !isNaN(payments.subscriptionStatus.numberOfDays) &&
    payments.subscriptionStatus.numberOfDays <= 31 && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {!couponApplied && subscriptionPlans && (
          <>
            <p className={classes.limitedOffer}>
              {numberFormatPaisaV2(
                subscriptionPlans.originalPrice
                  ? Number(subscriptionPlans.originalPrice)
                  : 0
              )}
            </p>
            <div className={classes.priceDiv}>
              <p className={classes.originalPrice}>
                {numberFormatPaisaV2(
                  subscriptionPlans.price ? Number(subscriptionPlans.price) : 0
                )}
              </p>
              <p className={classes.perYear}>Per Year</p>
            </div>
            <p
              className={classes.doYouHaveCouponCode}
              onClick={handleCouponDialog}
            >
              Do you have a coupon code?
            </p>
          </>
        )}
        {couponApplied && subscriptionPlans && (
          <div className={classes.offerAppliedMain}>
            <Box className={classes.offerApplied}>
              <LocalOfferIcon style={{ color: "#ffa412" }} />
              &nbsp;
              {discountType && discountType === "PERCENTAGE" && (
                <Typography className={classes.discountPer}>
                  {numberFormatPaisaV2(Number(discountValue))}% off
                </Typography>
              )}
              {discountType && discountType === "AMOUNT" && (
                <Typography className={classes.discountPer}>
                  {numberFormatPaisaV2(Number(discountValue))} off
                </Typography>
              )}
              &nbsp;<Typography>Offer Applied</Typography>
            </Box>
            <p className={classes.limitedOffer}>
              {numberFormatPaisaV2(
                subscriptionPlans.originalPrice
                  ? Number(subscriptionPlans.originalPrice)
                  : 0
              )}
            </p>
            <div className={classes.priceDiv}>
              <p className={classes.originalPrice}>
                {numberFormatPaisaV2(priceCoupon)}
              </p>
              <p className={classes.perYear}>Per Year</p>
            </div>
          </div>
        )}
        <Button
          variant="contained"
          className={classes.renewButton}
          onClick={e => {
            makePayment(subscriptionPlans);
          }}
        >
          Renew Now
        </Button>
      </div>
    );

  return (
    <Wrapper>
      {render_premium_info_card()}
      <Paper className={classes.premimumCard}>
        {render_premium_features()}
        {render_expiry_date()}
        {render_renew_option()}
      </Paper>
      {render_coupon_dialog()}
    </Wrapper>
  );
};
const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => ({
  dispatchGetSubscriptionPlanAction: (onSuccess, onFailure) => {
    dispatch(getSubscriptionPlans(onSuccess, onFailure));
  },
  dispatchPayForSubscriptionAction: (data, onSuccess, onFailure) => {
    dispatch(paySubscriptionAction(data, onSuccess, onFailure));
  },
  dispatchPayCouponSubscriptionAction: (data, onSuccess, onFailure) => {
    dispatch(getPlansAfterCouponApply(data, onSuccess, onFailure));
  },
  dispatchGetSubscriptionStatusAction: (onSuccess, onFailure) => {
    dispatch(getSubscriptionStatus(onSuccess, onFailure));
  },
  dispatchGetSubscriptionPaymentLinkAction: (id, onSuccess, onFailure) => {
    dispatch(getPaymentLink(id, onSuccess, onFailure));
  },
});
const PaymentsWithRouter = withRouter(Payments);
export default connect(mapStateToProps, mapDispatchToProps)(PaymentsWithRouter);
